import React from "react";
import { Tooltip } from "@material-ui/core";
import moment from "moment";
import { CgArrowTopRightR } from "react-icons/cg";
import { getImpactEvulations } from "services/NexiDigitalAPI";
import BaseAccordionTable, { Status, IconStatus } from "../BaseAccordionTable";
import "./styles.scss";
import { useHistory } from "react-router-dom";

const AccordionTable = ({ item, idUser }) => {
  const history = useHistory();

  const loadData = async () => {
    const result = await getImpactEvulations(idUser, {
      impactEvaluationMode: "INDIVIDUAL",
    });
    return result.data;
  };

  const columns = [
    {
      name: "Treinamento",
      selector: "title",
      sortable: false,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
    },
    {
      name: "Disponível em",
      selector: "creationDate",
      sortable: false,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: ({ creationDate }) => (
        <div>
          <span>{creationDate ? moment(creationDate).format("MMM D, YYYY") : ""}</span>
        </div>
      ),
    },
    {
      name: "Prazo",
      selector: "startDate",
      sortable: false,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: ({ startDate }) => (
        <div>
          <span>{startDate ? moment(startDate).add(30, "days").format("MMM D, YYYY") : ""}</span>
        </div>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: false,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: ({ startDate }) => (
        <IconStatus status={startDate ? Status.PENDING : Status.NOTSTARTED} />
      ),
    },
    {
      name: "Ação",
      sortable: false,
      selector: "idGroups",
      width: "200px",
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: ({ idQuestionnaire, idUser }) => (
        <div className="groupActions" key={idQuestionnaire}>
          <Tooltip title="Ir para avaliação" placement="top">
            <button
              className="btn btn-sm float-right icon-leave"
              onClick={() => {
                history.push(`/impact-evaluation/${idQuestionnaire}/${idUser}`);
              }}
            >
              <CgArrowTopRightR />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <BaseAccordionTable
      item={item}
      title={item.name}
      enablePagination={false}
      subtitle={item.role}
      image={item.photo}
      columns={columns}
      loadData={loadData}
      noDataMessage="Sem itens encontrados"
    />
  );
};

export default AccordionTable;
